export const GlobalComponent = {
    // Api Calling
    API_URL : 'https://api3.cinetyk.com/',
    headerToken : {'Authorization': `Bearer ${localStorage.getItem('token')}`},

    // Auth Api
    //AUTH_API:"https://api-node.themesbrand.website/auth/",
    AUTH_API:"https://api3.cinetyk.com/auth",

    BASE_PATH_IMAGE : "https://api3.cinetyk.com/images/products/"
}

declare global {
    interface Window {
        paypal:any;
    }
}